import React, {useEffect, useState} from 'react';
import {endBefore, getDatabase, onValue, orderByChild, query, ref} from "firebase/database";
import app from "../firebaseConfig/firebaseConfig";
import AdminOrderListItem from "./Components/AdminOrderListItem";
import Button from "@mui/material/Button";
import {Trans} from "react-i18next";
import {useNavigate} from "react-router";

const db = getDatabase(app);

const placedOrdersPath = `/placedOrders`;

function OrdersPage(props) {
    const navigate = useNavigate();
    const [orders, setOrders] = useState();

    useEffect(() => {
        if (!db) {
            return;
        }

        const orderRef = ref(db, placedOrdersPath);
        onValue(query(orderRef, orderByChild('status'), endBefore(4)), (snapshot) => {
            setOrders(snapshot.val());
        });
    }, []);

    const sortFunction = (a, b) => {
        return orders[a].date.localeCompare(orders[b].date)
    }

    return (
        <div className="orderspage">
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate(-1)}>&lt; <Trans i18nKey={'buttons.back'}/></Button>

            {Object.keys(orders || {}).sort(sortFunction).map(key =>
                <AdminOrderListItem orderRef={orders[key]} key={key} placedOrderRef={`${placedOrdersPath}/${key}`}/>)}
        </div>
    );
}

export default OrdersPage;
